import {ResourceParams} from "../resources";

export type MainResourceType =
  'record-lists' |
  'record-calendars' |
  'record-checks' |
  'documents' |
  'bloggers' |
  'telegram' |
  'tech-tasks';

export const mainResources: {
  [key in MainResourceType]: ResourceParams
} = {
  'record-lists': {
    key: 'record-lists',
    name: 'Предложения о сотрудничестве',
    path: 'record-lists',
  },
  'record-calendars': {
    key: 'record-calendars',
    name: 'Рекламные Кампании',
    path: 'record-calendars',
  },
  'record-checks': {
    key: 'record-checks',
    name: 'Список Проверяющего',
    path: 'record-checks',
  },
  'documents': {
    key: 'documents',
    name: 'Документы',
    path: 'documents',
  },
  'bloggers': {
    key: 'bloggers',
    name: 'Блогеры',
    path: 'bloggers',
  },
  'telegram': {
    key: 'telegram',
    name: 'Telegram',
    path: 'telegram',
  },
  'tech-tasks': {
    key: 'tech-tasks',
    name: 'Тех. задание',
    path: 'tech-tasks',
  },
};
